import { createSlice } from '@reduxjs/toolkit';
import {pickXApi} from "../pickX/pickX.api";
import {subToGroup} from "../../services/hub/Connection";
import ResourceTypes from "../../constants/ResourceType";

const initialState = {
    games: {},
    players: {},
    playersStats: {},
};

const sportsSlice = createSlice({
    name: 'sports',
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {

        builder.addCase("ws/gameSummaryDataChanged", (state, action) => {
            const gameId = action.payload.GameId;
            const game = state.games[gameId];
            if (game){
                action.payload.Changes.forEach( c=>{
                    switch(c.Name){
                        case "DateTime": game.DateTime = c.newValue; break;
                        case "GL":
                        case "GameLeft": game.GL = c.newValue; break;
                        case "Status": game.Status = c.newValue; break;
                        case "MatchStatus": game.MatchStatus = c.newValue; break;
                        case "Clock": game.Clock = c.newValue; break;
                        case "HomeTeamScore":
                        case "HomeScore": game.HomeTeamScore = c.newValue; break;
                        case "AwayTeamScore":
                        case "AwayScore": game.AwayTeamScore = c.newValue; break;
                        case "Period": game.Period = c.newValue; break;
                        case "Quarter": game.Quarter = c.newValue; break;
                        case "HomeTeamRuns": game.HomeTeamScore = c.newValue; break;
                        case "AwayTeamRuns": game.AwayTeamScore = c.newValue; break;
                        case "IsTop" : game.IsTop = c.newValue; break;
                        case "Inning": game.Inning = c.newValue; break;
                        case "TimeRemainingMinutes": game.TimeRemainingMinutes = c.newValue; break;
                        case "TimeRemainingSeconds": game.TimeRemainingSeconds = c.newValue; break;
                    }
            });
            }
        });

        builder.addCase("ws/gameStarted", (state, action) => {
            const gameId = action.payload.GameId;
            const game = state.games[gameId];
            if (game){
                game.Status = "inprogress";
                game.GL = 0.9999;
            }
        });
        builder.addCase("ws/gameEnded", (state, action) => {
            const gameId = action.payload.GameId;
            const game = state.games[gameId];
            if (game){
                game.Status = "closed";
                game.GL = 0;
            }
        });

        builder.addMatcher(pickXApi.endpoints.getContestsLobbyData.matchFulfilled,
            (state, action) => {
                processSportsPayloadData(state, action.payload);
            }
        );
        builder.addMatcher(pickXApi.endpoints.getContestsByIds.matchFulfilled,
            (state, action) => {
                processSportsPayloadData(state, action.payload);
            }
        );
        builder.addMatcher(pickXApi.endpoints.getPreSelectedParlayById.matchFulfilled,
            (state, action) => {
                processSportsPayloadData(state, action.payload);
        });
    }
});

const processSportsPayloadData = (state, payload) => {
    payload.Games.forEach(g => {
        state.games[g.GameId] = g;
        subToGroup(ResourceTypes.SPORTS, "gameId-"+g.GameId, true);
    });
    payload.Players.forEach(p => {
        state.players[p.PlayerId] = p;
    });
    payload.PlayersStats.forEach(ps => {
        state.playersStats[`${ps.PlayerId}-${ps.GameId}`] = ps;
    });
};

export const { } = sportsSlice.actions;

export default sportsSlice;